import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Manufacturer } from "../types/auth";

interface AuthState {
  user: Manufacturer | null;
  token: string | null;
  hasHydrated: boolean;
  setAuth: (user: Manufacturer, token: string) => void;
  logout: () => void;
  updateUser: (user: Partial<Manufacturer>) => void;
  setHasHydrated: (state: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      hasHydrated: false,
      setAuth: (user, token) => set({ user, token }),
      logout: () => set({ user: null, token: null }),
      updateUser: (updatedUser) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updatedUser } : null,
        })),
      setHasHydrated: (state) => set({ hasHydrated: state }),
    }),
    {
      name: "manufacturer-auth-storage",
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    },
  ),
);
